<template>
    <v-card class="ma-2 pa-0">
        <progress
            v-if="isLoading"
            class="progress is-small is-primary"
        ></progress>
        <div v-if="isLoader == false">
            <v-row justify="start" no-gutters>
                <div>
                    <div
                        style="
                            color: #33b642;
                            background: #33b64216;
                            padding: 4px;
                            width: fit-content;
                            border-top-right-radius: 6px;
                            border-bottom-right-radius: 6px;
                            margin-top: 12px;
                        "
                        v-if="userData.verified"
                    >
                        <v-icon color="#33B642" class="pa-0 ma-0"
                            >mdi-check-circle</v-icon
                        >
                        Verified Profile
                    </div>
                    <div
                        style="
                            color: #e42c64;
                            background: #e42c6416;
                            padding: 4px;
                            width: fit-content;
                            border-top-right-radius: 6px;
                            border-bottom-right-radius: 6px;
                            margin-top: 12px;
                        "
                        v-else
                    >
                        <img src="./icons/Error.svg" alt="" />
                        Not Verified
                    </div>
                </div>
                <div
                    style="
                        color: #0085ff;
                        padding: 4px;
                        width: fit-content;
                        border-top-right-radius: 6px;
                        border-bottom-right-radius: 6px;
                        margin: 4px;
                        display: flex;
                        align-items: center;
                    "
                >
                    <!-- <v-icon color="#0085FF">mdi-account</v-icon> Public Profile -->
                    <!-- <v-btn
                    class="ml-2"
                    icon
                    v-if="shareUrl"
                    v-clipboard:copy="shareUrl"
                    v-clipboard:success="copyUrl"
                >
                    <img
                        style="margin-left: 8px; padding-right: 6px"
                        src="./icons/Copy.svg"
                        alt=""
                    />
                </v-btn> -->
                </div>
            </v-row>
            <v-row no-gutters>
                <v-col cols="9">
                    <v-row no-gutters>
                        <div class="profileName" v-if="userData.gigerName">
                            <span
                                style="
                                    color: #fff;
                                    font-size: 36px;
                                    font-weight: 300;
                                "
                                class="px-5"
                                >{{ userData.gigerName }}
                            </span>
                            <!-- <span
                            style="
                                color: #fff;
                                background: #ffffff16;
                                border-radius: 6px;
                                padding: 4px;
                                font-size: 14px;
                            "
                            class="mx-1"
                            v-if="userData.loginMobile"
                        >
                            <v-icon color="#fff" small> mdi-phone </v-icon>
                            {{ userData.loginMobile }}
                        </span> -->
                            <!-- <v-btn
                            class="ml-3"
                            icon
                            v-if="userData.loginMobile"
                            v-clipboard:copy="userData.loginMobile"
                            v-clipboard:success="copyUrl"
                        >
                            <img
                                style="margin-left: 8px; padding-right: 6px"
                                src="./icons/Copy.svg"
                                alt=""
                            />
                        </v-btn> -->
                        </div>
                    </v-row>
                    <v-row no-gutters class="px-3 py-7">
                        <div class="pl-2 bullet" v-if="userData.gender">
                            <img
                                style="margin-left: 8px"
                                src="./icons/Ellipse.svg"
                                alt=""
                            />
                            Gender:
                            <span style="color: #912a6a">{{
                                userData.gender
                            }}</span>
                        </div>
                        <div class="pl-2 bullet" v-if="userData.dateOfBirth">
                            <img
                                style="margin-left: 8px"
                                src="./icons/Ellipse.svg"
                                alt=""
                            />
                            Date of Birth:
                            <span style="color: #912a6a">{{
                                formatDate(userData.dateOfBirth)
                            }}</span>
                        </div>
                        <div class="pl-2 bullet" v-else-if="userData.ageGroup">
                            <img
                                style="margin-left: 8px"
                                src="./icons/Ellipse.svg"
                                alt=""
                            />
                            Age Group:
                            <span style="color: #912a6a">{{
                                userData.ageGroup
                            }}</span>
                        </div>
                        <div
                            class="pl-2 bullet"
                            v-if="userData.vaccinationStatus"
                        >
                            <img
                                style="margin-left: 8px"
                                src="./icons/Ellipse.svg"
                                alt=""
                            />
                            Vaccination Status:
                            <span style="color: #912a6a">{{
                                checkVaccination()
                            }}</span>
                        </div>
                        <div class="pl-2 bullet" v-if="userData.gigerCode">
                            <img
                                style="margin-left: 8px"
                                src="./icons/Ellipse.svg"
                                alt=""
                            />
                            Giger Code:
                            <span style="color: #912a6a">{{
                                userData.gigerCode
                            }}</span>
                            <!-- <v-btn
                            class="ml-3"
                            icon
                            v-if="userData.gigerCode"
                            v-clipboard:copy="userData.gigerCode"
                            v-clipboard:success="copyUrl"
                        >
                            <img
                                style="margin-left: 8px; padding-right: 6px"
                                src="./icons/Copy.svg"
                                alt=""
                            />
                        </v-btn> -->
                        </div>
                    </v-row>
                </v-col>
                <v-col cols="3">
                    <div style="position: relative; margin-top: -40px">
                        <img
                            src="./icons/DESIGNELEMENTS.svg"
                            alt=""
                            style="position: absolute; top: 23px; left: -60px"
                        />
                        <img
                            src="./icons/ProfileBG.svg"
                            style="
                                position: absolute;
                                top: 0px;
                                left: 40px;
                                min-height: 250px;
                                min-width: 250px;
                            "
                            alt=""
                        />
                        <img
                            style="
                                width: 240px;
                                height: 240px;
                                position: absolute;
                                top: 21px;
                                left: 61px;
                                border-radius: 50%;
                            "
                            lazy-src="../../public/img/public_profile_avatar.svg"
                            :src="profilePic"
                            alt=""
                        />
                    </div>
                </v-col>
            </v-row>
            <v-row class="px-2">
                <v-col class="px-4 pt-0 pb-4">
                    <v-row class="pb-2" no-gutters
                        ><h3>Document Status</h3></v-row
                    >
                    <!-- <v-row no-gutters style="width: 90%">
                    <v-progress-linear
                        background-color="#F2F4F5"
                        color="#912A6A"
                        height="1"
                        value="15"
                    ></v-progress-linear>
                </v-row> -->
                    <v-row
                        no-gutters
                        class="pt-2 flex-row-reverse"
                        justify="space-between"
                        v-if="userData.documents"
                    >
                        <div
                            v-for="item of userData.documents"
                            :key="item"
                            style="font-size: 14px"
                        >
                            <span style="color: #979c9e">{{ item.name }}: </span
                            ><span
                                :style="
                                    item.value == 'Verified'
                                        ? 'color:#33b642'
                                        : item.value == 'Not Verified'
                                        ? 'color:#000000'
                                        : 'color:#0085FF'
                                "
                                >{{ item.value }}</span
                            >
                        </div>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-card
                    elevation="0"
                    class="pa-4 ma-2 elevation-0"
                    color="#F2F5F8"
                    width="100%"
                >
                    <v-row no-gutters>
                        <v-col
                            class="align-center pa-2"
                            v-if="userData.totalAmountByGig4ce"
                        >
                            <v-card class="pa-1 rounded-lg elevation-0 ma-3">
                                <div
                                    style="
                                        color: #e42c64;
                                        font-size: 36px;
                                        font-weight: 700;
                                    "
                                    class="pa-2 text-center"
                                >
                                    Rs. {{ userData.totalAmountByGig4ce }}
                                </div>
                                <div
                                    style="
                                        background: #d52c6510;
                                        border-radius: 6px;
                                    "
                                    class="
                                        text-center
                                        align-center
                                        elevation-0
                                        pa-1
                                        ma-1
                                    "
                                >
                                    Total Earnings with Gig4ce
                                </div>
                            </v-card>
                        </v-col>

                        <v-col
                            class="align-center pa-2"
                            v-if="
                                userData.currentActivations &&
                                userData.currentActivations.length
                            "
                        >
                            <v-card class="pa-1 rounded-lg elevation-0 ma-3">
                                <div
                                    style="
                                        color: #22c7f7;
                                        font-size: 36px;
                                        font-weight: 700;
                                    "
                                    class="pa-2 text-center"
                                >
                                    {{ userData.currentActivations.length }}
                                </div>
                                <div
                                    style="
                                        background: #22b4e710;
                                        border-radius: 6px;
                                    "
                                    class="
                                        text-center
                                        align-center
                                        elevation-0
                                        pa-1
                                        ma-1
                                    "
                                >
                                    Current Active Gigs
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col
                            class="align-center pa-2"
                            v-if="userData.randomRating"
                        >
                            <v-card class="pa-1 rounded-lg elevation-0 ma-2">
                                <div
                                    style="
                                        color: #1d70fc;
                                        font-size: 24px;
                                        font-weight: 700;
                                    "
                                    class="pa-2 text-center"
                                >
                                    {{ userData.randomRating }}
                                </div>
                                <div
                                    style="
                                        background: #22b4e710;
                                        border-radius: 6px;
                                    "
                                    class="
                                        text-center
                                        align-center
                                        elevation-0
                                        pa-1
                                        ma-1
                                    "
                                >
                                    Ratings
                                </div>
                            </v-card>
                        </v-col>
                        <v-col
                            class="align-center pa-2"
                            v-if="userData.taskDone"
                        >
                            <v-card class="pa-1 rounded-lg elevation-0 ma-2">
                                <div
                                    style="
                                        color: #33b642;
                                        font-size: 24px;
                                        font-weight: 700;
                                    "
                                    class="pa-2 text-center"
                                >
                                    {{ userData.taskDone }}
                                </div>
                                <div
                                    style="
                                        background: #33b64210;
                                        border-radius: 6px;
                                    "
                                    class="
                                        text-center
                                        align-center
                                        elevation-0
                                        pa-1
                                        ma-1
                                    "
                                >
                                    Task Done
                                </div>
                            </v-card>
                        </v-col>
                        <v-col
                            class="align-center pa-2"
                            v-if="userData.onTimeAttendance"
                        >
                            <v-card class="pa-1 rounded-lg elevation-0 ma-2">
                                <div
                                    style="
                                        color: #ff9c40;
                                        font-size: 24px;
                                        font-weight: 700;
                                    "
                                    class="pa-2 text-center"
                                >
                                    {{ userData.onTimeAttendance }} %
                                </div>
                                <div
                                    style="
                                        background: #ff9c4010;
                                        border-radius: 6px;
                                    "
                                    class="
                                        text-center
                                        align-center
                                        elevation-0
                                        pa-1
                                        ma-1
                                    "
                                >
                                    On Time Attendance
                                </div>
                            </v-card>
                        </v-col>
                        <v-col
                            class="align-center pa-2"
                            v-if="userData.informedLeaves"
                        >
                            <v-card class="pa-1 rounded-lg elevation-0 ma-2">
                                <div
                                    style="
                                        color: #ff4079;
                                        font-size: 24px;
                                        font-weight: 700;
                                    "
                                    class="pa-2 text-center"
                                >
                                    {{ userData.informedLeaves }} %
                                </div>
                                <div
                                    style="
                                        background: #ff407910;
                                        border-radius: 6px;
                                    "
                                    class="
                                        text-center
                                        align-center
                                        elevation-0
                                        pa-1
                                        ma-1
                                    "
                                >
                                    Informed Leaves
                                </div>
                            </v-card>
                        </v-col>
                        <v-col
                            class="align-center pa-2"
                            v-if="userData.unInformedLeaves"
                        >
                            <v-card class="pa-1 rounded-lg elevation-0 ma-2">
                                <div
                                    style="
                                        color: #b6a933;
                                        font-size: 24px;
                                        font-weight: 700;
                                    "
                                    class="pa-2 text-center"
                                >
                                    {{ userData.unInformedLeaves }} %
                                </div>
                                <div
                                    style="
                                        background: #b6a93310;
                                        border-radius: 6px;
                                    "
                                    class="
                                        text-center
                                        align-center
                                        elevation-0
                                        pa-1
                                        ma-1
                                    "
                                >
                                    Uninformed Leaves
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-row>
            <v-row class="px-2">
                <v-col>
                    <v-row
                        v-if="
                            userData.currentActivations &&
                            userData.currentActivations.length
                        "
                    >
                        <v-col cols="1">
                            <img src="./icons/CurrentActivation.svg" alt="" />
                        </v-col>
                        <v-col cols="11">
                            <h2 class="py-3">Current Activation</h2>

                            <v-card
                                rounded="pill"
                                color="#22C7F710"
                                class="my-2 px-2 pill elevation-0"
                                elevation="0"
                                v-for="item of userData.currentActivations"
                                :key="item._id"
                            >
                                <v-row
                                    no-gutters
                                    justify="space-between"
                                    class=""
                                >
                                    <v-col
                                        cols="4"
                                        style="
                                            display: flex;
                                            align-items: center;
                                            font-weight: 600;
                                        "
                                    >
                                        <img
                                            src="./icons/BusinessName.svg"
                                            alt=""
                                            class="px-1"
                                        />Business Name:
                                        <span
                                            style="color: #222e78"
                                            class="pl-1"
                                            >{{ item.business }}</span
                                        >
                                    </v-col>
                                    <v-col
                                        cols="4"
                                        style="
                                            display: flex;
                                            align-items: center;
                                            font-weight: 600;
                                        "
                                    >
                                        <img
                                            src="./icons/Profile.svg"
                                            alt=""
                                            class="px-1"
                                        />Job Profile:
                                        <span
                                            style="color: #222e78"
                                            class="pl-1"
                                            >{{ item.profile }}</span
                                        >
                                    </v-col>
                                    <v-col
                                        cols="4"
                                        style="
                                            display: flex;
                                            align-items: center;
                                            font-weight: 600;
                                        "
                                    >
                                        <img
                                            src="./icons/Calendar.svg"
                                            alt=""
                                            class="px-1"
                                        />Date of Activation:
                                        <span
                                            style="color: #222e78"
                                            class="pl-1"
                                            >{{ item.createdOn }}</span
                                        >
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="1">
                            <img src="./icons/workInfo.svg" alt="" />
                        </v-col>
                        <v-col cols="11">
                            <h2 class="py-3">Work Information</h2>

                            <v-card class="pa-2">
                                <v-row no-gutters justify="space-between">
                                    <div
                                        v-if="
                                            userData.preferredJobLocation &&
                                            userData.preferredJobLocation
                                                .city_name
                                        "
                                    >
                                        <img
                                            style="margin-left: 8px"
                                            src="./icons/Location.svg"
                                            alt=""
                                        />
                                        Preferred City:
                                        <span style="color: #93447e">
                                            {{
                                                userData.preferredJobLocation
                                                    .city_name
                                            }}</span
                                        >
                                    </div>
                                    <div class="pl-2" v-if="userData.jobType">
                                        <img
                                            style="margin-left: 8px"
                                            src="./icons/Availability.svg"
                                            alt=""
                                        />
                                        Availability Preference:
                                        <span style="color: #93447e">
                                            {{ userData.jobType }}</span
                                        >
                                    </div>
                                    <div
                                        class="pl-2"
                                        v-if="
                                            userData.earningPreference &&
                                            (userData.earningPreference
                                                .perDayGoal ||
                                                userData.earningPreference
                                                    .perMonthGoal)
                                        "
                                    >
                                        Earning Preference:
                                        <span style="color: #93447e">
                                            {{
                                                userData.earningPreference
                                                    .perDayGoal >= 0
                                                    ? "Daily- Rs." +
                                                      userData.earningPreference
                                                          .perDayGoal
                                                    : ""
                                            }}
                                            {{
                                                userData.earningPreference
                                                    .perDayGoal >= 0 &&
                                                userData.earningPreference
                                                    .perMonthGoal >= 0
                                                    ? ", "
                                                    : ""
                                            }}
                                            {{
                                                userData.earningPreference
                                                    .perMonthGoal >= 0
                                                    ? "Monthly- Rs." +
                                                      userData.earningPreference
                                                          .perMonthGoal
                                                    : ""
                                            }}
                                        </span>
                                    </div>
                                </v-row>

                                <hr
                                    v-if="userData.earningPreference"
                                    style="background: #f2f4f5"
                                />
                                <div
                                    v-if="
                                        userData.skills &&
                                        userData.skills.length
                                    "
                                >
                                    <h3>Preferred Interests</h3>

                                    <v-row no-gutters>
                                        <v-card
                                            class="px-2 ma-1 elevation-0"
                                            elevation="0"
                                            color="#F1F6FF"
                                            v-for="item of userData.skills"
                                            :key="item"
                                            >{{ item.id }}</v-card
                                        >
                                    </v-row>
                                </div>

                                <h3
                                    v-if="
                                        userData.experiences &&
                                        userData.experiences.length
                                    "
                                >
                                    Previous Experience
                                </h3>

                                <v-card
                                    rounded="pill"
                                    color="#E42C6410"
                                    class="ma-2 px-2 pill elevation-0"
                                    elevation="0"
                                    v-for="item of userData.experiences"
                                    :key="item"
                                >
                                    <v-row
                                        no-gutters
                                        justify="space-between"
                                        class="py-1 px-2"
                                    >
                                        <div
                                            v-if="item.company"
                                            style="
                                                display: flex;
                                                align-items: center;
                                                font-weight: 600;
                                            "
                                        >
                                            Company Name:
                                            <span
                                                style="color: #93447e"
                                                class="pl-1"
                                                >{{ item.company }}</span
                                            >
                                        </div>
                                        <div
                                            v-if="item.title"
                                            style="
                                                display: flex;
                                                align-items: center;
                                                font-weight: 600;
                                            "
                                        >
                                            Job Profile:
                                            <span
                                                style="color: #93447e"
                                                class="pl-1"
                                                >{{ item.title }}</span
                                            >
                                        </div>
                                        <div
                                            v-if="item.totalExperence"
                                            style="
                                                display: flex;
                                                align-items: center;
                                                font-weight: 600;
                                            "
                                        >
                                            Duration:
                                            <span
                                                style="color: #93447e"
                                                class="pl-1"
                                                >{{ item.totalExperence }}</span
                                            >
                                        </div>
                                    </v-row>
                                </v-card>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="1">
                            <img src="./icons/personalInfo.svg" alt="" />
                        </v-col>
                        <v-col cols="11">
                            <h2 class="py-3">Personal Information</h2>

                            <v-card
                                v-if="userData.aboutMe"
                                elevation="0"
                                style="border: 1px solid #2cdcc8"
                                class="pa-2 pb-6 elevation-0"
                            >
                                <h3 class="py-2" style="color: #222671">
                                    About Me
                                </h3>
                                <span
                                    style="
                                        font-weight: 300px;
                                        font-size: 18px;
                                        text-align: left;
                                        position: absolute;
                                        left: 25px;
                                    "
                                    >{{ userData.aboutMe }}</span
                                >
                            </v-card>
                            <div class="ma-2" v-if="userData.highestEducation">
                                <h3 class="py-2">Highest Education</h3>
                                <v-row class="px-2" no-gutters>
                                    {{ userData.highestEducation }}
                                </v-row>
                            </div>
                            <v-row no-gutters>
                                <v-col
                                    v-if="
                                        userData.languages &&
                                        userData.languages.length
                                    "
                                    class="ma-2"
                                >
                                    <h3 class="px-2">Language Spoken</h3>

                                    <v-row class="px-2" no-gutters>
                                        <v-card
                                            v-for="item of userData.languages"
                                            :key="item"
                                            class="px-2 mx-1 elevation-0"
                                            elevation="0"
                                            color="#F1F6FF"
                                            >{{ item.name }}</v-card
                                        >
                                    </v-row>
                                </v-col>
                                <v-col
                                    v-if="
                                        userData.assets &&
                                        userData.assets.length
                                    "
                                    class="ma-2"
                                >
                                    <h3 class="px-2">Assets Owned</h3>

                                    <v-row class="px-2" no-gutters>
                                        <v-card
                                            v-for="item of userData.assets"
                                            :key="item"
                                            class="pa-1 mx-1 elevation-0"
                                            elevation="0"
                                            color="#F1F6FF"
                                            >{{ item && item.name }}</v-card
                                        >
                                    </v-row>
                                </v-col>
                            </v-row>
                            <!-- <v-row
                                class="pa-2"
                                no-gutters
                                v-if="
                                    userData.address &&
                                    ((userData.address.current &&
                                        !userData.address.current.empty) ||
                                        (userData.address.home &&
                                            !userData.address.home.empty))
                                "
                            >
                                <v-col
                                    class="ma-1"
                                    v-if="
                                        userData.address.current &&
                                        !userData.address.current.empty
                                    "
                                >
                                    <h3 class="py-2">Current Address</h3>
                                    <v-card
                                        v-if="
                                            userData.address.current.firstLine
                                        "
                                        style="border: 1px solid #e3e5e5"
                                        elevation="0"
                                        class="elevation-0"
                                    >
                                        <v-row no-gutters class="pa-1">
                                            <v-col
                                                cols="3"
                                                style="color: #979c9e"
                                                >Address Line 1</v-col
                                            >
                                            <v-col cols="1">:</v-col>
                                            <v-col cols="6">
                                                {{
                                                    userData.address.current
                                                        .firstLine
                                                }}</v-col
                                            >
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="
                                            userData.address.current.secondLine
                                        "
                                        style="border: 1px solid #e3e5e5"
                                        elevation="0"
                                        class="elevation-0"
                                    >
                                        <v-row no-gutters class="pa-1">
                                            <v-col
                                                cols="3"
                                                style="color: #979c9e"
                                                >Address Line 2</v-col
                                            >
                                            <v-col cols="1">:</v-col>
                                            <v-col cols="6">
                                                {{
                                                    userData.address.current
                                                        .secondLine
                                                }}</v-col
                                            >
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="userData.address.current.city"
                                        style="border: 1px solid #e3e5e5"
                                        elevation="0"
                                        class="elevation-0"
                                    >
                                        <v-row no-gutters class="pa-1">
                                            <v-col
                                                cols="3"
                                                style="color: #979c9e"
                                                >City</v-col
                                            >
                                            <v-col cols="1">:</v-col>
                                            <v-col cols="6">
                                                {{
                                                    userData.address.current
                                                        .city
                                                }}</v-col
                                            >
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="userData.address.current.state"
                                        style="border: 1px solid #e3e5e5"
                                        elevation="0"
                                        class="elevation-0"
                                    >
                                        <v-row no-gutters class="pa-1">
                                            <v-col
                                                cols="3"
                                                style="color: #979c9e"
                                                >State</v-col
                                            >
                                            <v-col cols="1">:</v-col>
                                            <v-col cols="6">
                                                {{
                                                    userData.address.current
                                                        .state
                                                }}</v-col
                                            >
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="userData.address.current.pincode"
                                        style="border: 1px solid #e3e5e5"
                                        elevation="0"
                                        class="elevation-0"
                                    >
                                        <v-row no-gutters class="pa-1">
                                            <v-col
                                                cols="3"
                                                style="color: #979c9e"
                                                >ZIP/Postal Code</v-col
                                            >
                                            <v-col cols="1">:</v-col>
                                            <v-col cols="6">
                                                {{
                                                    userData.address.current
                                                        .pincode
                                                }}</v-col
                                            >
                                        </v-row>
                                    </v-card>
                                </v-col>
                                <v-col
                                    class="ma-1"
                                    v-if="
                                        userData.address.home &&
                                        !userData.address.home.empty
                                    "
                                >
                                    <h3 class="py-2">Permanent Address</h3>
                                    <v-card
                                        v-if="userData.address.home.firstLine"
                                        style="border: 1px solid #e3e5e5"
                                        elevation="0"
                                        class="elevation-0"
                                    >
                                        <v-row no-gutters class="pa-1">
                                            <v-col
                                                cols="3"
                                                style="color: #979c9e"
                                                >Address Line 1</v-col
                                            >
                                            <v-col cols="1">:</v-col>
                                            <v-col cols="8">
                                                {{
                                                    userData.address.home
                                                        .firstLine
                                                }}</v-col
                                            >
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="userData.address.home.secondLine"
                                        style="border: 1px solid #e3e5e5"
                                        elevation="0"
                                        class="elevation-0"
                                    >
                                        <v-row no-gutters class="pa-1">
                                            <v-col
                                                cols="3"
                                                style="color: #979c9e"
                                                >Address Line 2</v-col
                                            >
                                            <v-col cols="1">:</v-col>
                                            <v-col cols="6">
                                                {{
                                                    userData.address.home
                                                        .secondLine
                                                }}</v-col
                                            >
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="userData.address.home.city"
                                        style="border: 1px solid #e3e5e5"
                                        elevation="0"
                                        class="elevation-0"
                                    >
                                        <v-row no-gutters class="pa-1">
                                            <v-col
                                                cols="3"
                                                style="color: #979c9e"
                                                >City</v-col
                                            >
                                            <v-col cols="1">:</v-col>
                                            <v-col cols="6">
                                                {{
                                                    userData.address.home.city
                                                }}</v-col
                                            >
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="userData.address.home.state"
                                        style="border: 1px solid #e3e5e5"
                                        elevation="0"
                                        class="elevation-0"
                                    >
                                        <v-row no-gutters class="pa-1">
                                            <v-col
                                                cols="3"
                                                style="color: #979c9e"
                                                >State</v-col
                                            >
                                            <v-col cols="1">:</v-col>
                                            <v-col cols="6">
                                                {{
                                                    userData.address.home.state
                                                }}</v-col
                                            >
                                        </v-row>
                                    </v-card>
                                    <v-card
                                        v-if="userData.address.home.pincode"
                                        style="border: 1px solid #e3e5e5"
                                        elevation="0"
                                        class="elevation-0"
                                    >
                                        <v-row no-gutters class="pa-1">
                                            <v-col
                                                cols="3"
                                                style="color: #979c9e"
                                                >ZIP/Postal Code</v-col
                                            >
                                            <v-col cols="1">:</v-col>
                                            <v-col cols="6">
                                                {{
                                                    userData.address.home
                                                        .pincode
                                                }}</v-col
                                            >
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row> -->
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>
<script>
import moment from "moment";
// import { notification } from "../../plugins/notification";
import { copyContent } from "./icons/Copy.svg";
import { getUserDetails, getProfileData } from "../service/webservice.js";
export default {
    name: "Profile",
    data: () => ({
        profilePic: "/images/avatars/avatar17.svg",
        icons: {
            copyContent,
        },
        shareUrl: "",
        userData: {},
        isLoader: false,
    }),
    props: {
        user: {},
    },
    methods: {
        getWebURL(id) {
            return `https://gigforce.in/users/` + id;
        },
        copyUrl: () => {
            // notification.success(`Copied Successfully !!!`);
        },
        formatDate(date) {
            return moment(date).format("DD-MM-YYYY");
        },
        checkVaccination() {
            switch (this.userData.vaccinationStatus) {
                case 0:
                    return "Not Vaccinated";
                case 1:
                    return "1st Dosage Completed";
                case 2:
                    return "Fully Vaccinated";
            }
        },
        async getProfilePic() {
            let data = await getProfileData(this.$route.params.id);
            if (data.profileUrl) this.profilePic = data.profileUrl;
            else
                this.profilePic =
                    "https://gigforce.in/img/public_profile_avatar.svg";
        },
        async setUserDetails() {
            this.isLoader = true;
            try {
                this.userData = await getUserDetails(this.$route.params.id);
                // this.profilePic = await storage.ref(this.userData["profileAvatarName"]).getDownloadURL();
                if (this.userData.documents) {
                    this.userData.documents.forEach((item) => {
                        if (item.aadharCardStatus) {
                            item.name = "Aadhar Card";
                            item.value = item.aadharCardStatus;
                        }
                        if (item.panCardStatus) {
                            item.name = "PAN Card";
                            item.value = item.panCardStatus;
                        }
                        if (item.dlStatus) {
                            item.name = "Driving Licence";
                            item.value = item.dlStatus;
                        }
                        if (item.bankStatus) {
                            item.name = "Bank Details";
                            item.value = item.bankStatus;
                        }
                        if (item.insuranceStatus) {
                            item.name = "Insurance";
                            item.value = item.insuranceStatus;
                        }
                    });
                    this.userData.documents.sort((a, b) => {
                        b;
                        if (a.item == "Verified") return 1;
                        else if (a.item == "Not Verified") return -1;
                        else return 0;
                    });
                }
                this.userData.assets = this.userData.assets.filter((item) => {
                    return (
                        item != null &&
                        item.name &&
                        item.name != "" &&
                        item.isSelected
                    );
                });
            } catch (e) {
                console.log(e);
            }
            this.isLoader = false;
        },
    },
    mounted() {
        this.shareUrl = this.getWebURL(this.$route.params.id);
        this.userId = this.$route.params.id;
        this.setUserDetails();
        this.getProfilePic();
    },
};
</script>
<style scoped>
.profileName {
    background: url("./icons/ProfileNameBack.svg");
    width: 750px;
    height: 110px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: -9px;
}
.bullet {
    font-weight: 400 !important;
    align-items: center !important;
    display: flex !important;
}
.pa-0 {
    padding: 0px;
}
.pa-1 {
    padding: 8px;
}
.pa-2 {
    padding: 16px;
}
.pa-3 {
    padding: 24px;
}
.pa-4 {
    padding: 32px;
}
.pt-0 {
    padding-top: 0px;
}
.pt-1 {
    padding-top: 8px;
}
.pt-2 {
    padding-top: 16px;
}
.pb-0 {
    padding-bottom: 0px;
}
.pb-1 {
    padding-bottom: 8px;
}
.pb-2 {
    padding-bottom: 16px;
}
.pb-4 {
    padding-bottom: 32px;
}
.pl-0 {
    padding-left: 0px;
}
.pl-1 {
    padding-left: 8px;
}
.pl-2 {
    padding-left: 16px;
}
.pr-0 {
    padding-right: 0px;
}
.pr-1 {
    padding-right: 8px;
}
.pr-2 {
    padding-right: 16px;
}
.px-0 {
    padding-right: 0px;
    padding-left: 0px;
}
.px-1 {
    padding-right: 8px;
    padding-left: 8px;
}
.px-2 {
    padding-right: 16px;
    padding-left: 16px;
}
.px-3 {
    padding-right: 24px;
    padding-left: 24px;
}
.py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
}
.py-1 {
    padding-top: 8px;
    padding-bottom: 8px;
}
.py-2 {
    padding-top: 16px;
    padding-bottom: 16px;
}
.py-3 {
    padding-top: 24px;
    padding-bottom: 24px;
}
.py-7 {
    padding-top: 56px;
    padding-bottom: 56px;
}
.ma-0 {
    margin: 0px;
}
.ma-1 {
    margin: 8px;
}
.ma-2 {
    margin: 16px;
}
.ma-3 {
    margin: 24px;
}
.ml-0 {
    margin-left: 0px;
}
.ml-1 {
    margin-left: 8px;
}
.ml-2 {
    margin-left: 16px;
}
.mr-0 {
    margin-right: 0px;
}
.mr-1 {
    margin-right: 8px;
}
.mr-2 {
    margin-right: 16px;
}
.align-center {
    align-content: center;
}
.col {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
}
.col-1 {
    flex-grow: 1;
}
.col-2 {
    flex-grow: 2;
}
.col-3 {
    flex-grow: 3;
}
.col-4 {
    flex-grow: 4;
}
.col-5 {
    flex-grow: 5;
}
.col-6 {
    flex-grow: 6;
}
.col-7 {
    flex-grow: 7;
}
.col-8 {
    flex-grow: 8;
}
.col-9 {
    flex-grow: 9;
}
.col-10 {
    flex-grow: 10;
}
.col-11 {
    flex-grow: 11;
}
.pill {
    border-radius: 1000px !important;
}
.rounded-lg {
    border-radius: 12px !important;
}
.justify-space-between {
    justify-content: space-between;
}
.elevation-0 {
    box-shadow: none !important;
}
h3,
h2 {
    text-align: left;
    font-weight: 700;
}
h3 {
    font-size: 18px;
}
h2 {
    font-size: 24px;
}
</style>